// The SDK is created only after an affirmative, server-confirmed consent.
export function createMetaPixel(panel, browser = window, doc = document) {
    const id = panel.dataset.metaPixel;
    let events = [];
    try { events = JSON.parse(panel.dataset.metaEvents || '[]'); } catch (_) { /* No tracking on malformed data. */ }
    let granted = false;
    let loaded = false;
    let pageSent = false;
    const sent = new Set();

    function track(event) {
        if (!granted || !loaded || !event || !['PageView', 'ViewContent', 'AddToCart', 'InitiateCheckout', 'Purchase'].includes(event.name)) return;
        if (event.name !== 'PageView' && !event.data?.content_ids?.length) return;
        const key = event.id ? 'almc-meta:' + event.id : null;
        if (key) {
            if (sent.has(key)) return;
            try { if (browser.sessionStorage.getItem(key)) return; } catch (_) { /* Storage is optional. */ }
        }
        browser.fbq('trackSingle', id, event.name, event.data || {}, event.id ? {eventID: event.id} : {});
        if (key) {
            sent.add(key);
            try { browser.sessionStorage.setItem(key, '1'); } catch (_) { /* In-memory deduplication remains. */ }
        }
    }

    function consent(choice) {
        granted = choice === true;
        if (!granted) {
            if (loaded) browser.fbq('consent', 'revoke');
            return;
        }
        if (!/^\d+$/.test(id || '') || events.length === 0) return;
        if (!loaded) {
            if (!browser.fbq) {
                const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
                fbq.queue = []; fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0';
                browser.fbq = browser._fbq = fbq;
                const script = doc.createElement('script');
                script.async = true;
                script.src = 'https://connect.facebook.net/en_US/fbevents.js';
                doc.head.appendChild(script);
            }
            browser.fbq('consent', 'grant');
            browser.fbq('set', 'autoConfig', false, id);
            browser.fbq('init', id);
            loaded = true;
        } else browser.fbq('consent', 'grant');
        if (!pageSent) { events.forEach(track); pageSent = true; }
    }

    return {consent, track};
}
